var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1213_21256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1 1.08133C10.815 0.843514 10.4805 0.672157 10.121 0.579703C9.7615 0.48725 9.3859 0.476022 9.0215 0.546834L8.1395 0.762834C7.67922 0.847181 7.26309 1.09025 6.96353 1.44974C6.66396 1.80924 6.49994 2.26239 6.5 2.73033V10.4638C6.16843 10.5123 5.83157 10.5123 5.5 10.4638V2.73033C5.50166 2.2667 5.34142 1.81704 5.04695 1.45894C4.75247 1.10083 4.34222 0.856759 3.887 0.768834L2.95 0.540834C2.58958 0.47488 2.21907 0.488959 1.86469 0.582071C1.51031 0.675184 1.18073 0.845055 0.899283 1.07966C0.617833 1.31427 0.391393 1.60787 0.235991 1.93969C0.0805891 2.27151 2.44062e-05 2.63343 0 2.99983L0 8.39633C2.87279e-05 8.98173 0.205488 9.54856 0.580567 9.99802C0.955645 10.4475 1.47655 10.751 2.0525 10.8558L5.1955 11.4273C5.72748 11.524 6.27252 11.524 6.8045 11.4273L9.95 10.8558C10.5255 10.7505 11.0458 10.4467 11.4204 9.99732C11.795 9.54792 12.0001 8.98138 12 8.39633V2.99983C12.0002 2.63356 11.9197 2.27173 11.7641 1.94013C11.6086 1.60853 11.3818 1.3153 11.1 1.08133Z",
    fill: "#262626"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1213_21256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookAlt);
export default __webpack_public_path__ + "static/media/book-alt.96885b0b76d4b56fc330381d089e72b1.svg";
export { ForwardRef as ReactComponent };